module.exports = __webpack_public_path__ + "img/feather-alt.5ade927c.svg";